// Types
import type { Row } from '@tanstack/react-table';

import type { SpGroupType } from '@/hooks/swr/group/useSPGroups';

import type { SocialProfileType } from '@/types/socialProfileType';

import type { KPIDataType } from '@/lib/analytics/kpis/kpi.type';

type RowDataType = {
    group?: SpGroupType;
    social_profile?: SocialProfileType;
};

const sortKpi = ({ valueA, valueB }: { valueA?: number; valueB?: number }) => {
    // make sure 0 is considered as a value
    if (typeof valueA !== 'number') {
        return -1;
    }

    // make sure 0 is considered as a value
    if (typeof valueB !== 'number') {
        return 1;
    }

    if (valueA === valueB) {
        return 0;
    }

    if (valueA > valueB) {
        return 1;
    }

    return -1;
};

export const sortTableGroupKpiColumn = <TRowDataType extends RowDataType>(
    rowA: Row<TRowDataType>,
    rowB: Row<TRowDataType>,
    columnId: string
) => {
    // Don't change position of the group row
    if (rowA.original?.group || rowB.original?.group) {
        return 0;
    }

    const getValueRowA = rowA.getValue<KPIDataType>(columnId)?.value;
    const getValueRowB = rowB.getValue<KPIDataType>(columnId)?.value;

    return sortKpi({ valueA: getValueRowA, valueB: getValueRowB });
};

export const sortTableKpiColumn = <TRowDataType>(
    rowA: Row<TRowDataType>,
    rowB: Row<TRowDataType>,
    columnId: string
) => {
    const getValueRowA = rowA.getValue<KPIDataType>(columnId)?.value;
    const getValueRowB = rowB.getValue<KPIDataType>(columnId)?.value;

    return sortKpi({ valueA: getValueRowA, valueB: getValueRowB });
};
